/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postConsigneeArticlesCompare } from '../fn/articles/post-consignee-articles-compare';
import { PostConsigneeArticlesCompare$Params } from '../fn/articles/post-consignee-articles-compare';

@Injectable({ providedIn: 'root' })
export class ArticlesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postConsigneeArticlesCompare()` */
  static readonly PostConsigneeArticlesComparePath = '/organization-sites/{organizationSiteKey}/consignee/articles-compare';

  /**
   * Upload a list of goods receipt articles for comparison.
   *
   * Receives a list of articles (max. 500) from S4HANA or Manhattan for comparison
   * with existing delivery note article positions.
   *
   * The comparison is based on the purchase order number (PO / articleOrderNumber)
   * and the item code (consigneeOrderNumber). Only organization sites with the
   * articlesCompare feature enabled may use this endpoint (e.g. ALDI SÜD).
   *
   * For each matched article position:
   * - If quantities match → position is marked green (checked)
   * - If goods receipt quantity > article quantity → red, automatic discrepancy "OVER_DELIVERED"
   * - If goods receipt quantity < article quantity → red, automatic discrepancy "UNDER_DELIVERED"
   * - If no match is found → nothing happens
   * - Summed matches in a bundle group are compared on the virtual article
   * - Multiple non-summed matches remain ambiguous → nothing happens
   *
   * Manual corrections by warehouse staff always take precedence over automatic ones.
   * Already processed positions are not overwritten by subsequent uploads.
   *
   * Duplicate articleOrderNumber + consigneeOrderNumber pairs within the request
   * are ignored, only the last entry is processed. With checkDuplicates=true the
   * request is rejected with 409 instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsigneeArticlesCompare()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsigneeArticlesCompare$Response(params: PostConsigneeArticlesCompare$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = postConsigneeArticlesCompare(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Upload a list of goods receipt articles for comparison.
   *
   * Receives a list of articles (max. 500) from S4HANA or Manhattan for comparison
   * with existing delivery note article positions.
   *
   * The comparison is based on the purchase order number (PO / articleOrderNumber)
   * and the item code (consigneeOrderNumber). Only organization sites with the
   * articlesCompare feature enabled may use this endpoint (e.g. ALDI SÜD).
   *
   * For each matched article position:
   * - If quantities match → position is marked green (checked)
   * - If goods receipt quantity > article quantity → red, automatic discrepancy "OVER_DELIVERED"
   * - If goods receipt quantity < article quantity → red, automatic discrepancy "UNDER_DELIVERED"
   * - If no match is found → nothing happens
   * - Summed matches in a bundle group are compared on the virtual article
   * - Multiple non-summed matches remain ambiguous → nothing happens
   *
   * Manual corrections by warehouse staff always take precedence over automatic ones.
   * Already processed positions are not overwritten by subsequent uploads.
   *
   * Duplicate articleOrderNumber + consigneeOrderNumber pairs within the request
   * are ignored, only the last entry is processed. With checkDuplicates=true the
   * request is rejected with 409 instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConsigneeArticlesCompare$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsigneeArticlesCompare(params: PostConsigneeArticlesCompare$Params, context?: HttpContext): Observable<void> {
    const resp = this.postConsigneeArticlesCompare$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
